import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CustomField, CustomFieldConstants, CustomFieldDropdownChoice } from '../../../../../models/custom-field.interface';
import { CustomValue } from '../../../../../models/custom-value';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'lib-risk-assessment-survey-custom-fields-modal',
  templateUrl: './risk-assessment-survey-custom-fields-modal.component.html',
  styleUrls: ['./risk-assessment-survey-custom-fields-modal.component.scss']
})
export class RiskAssessmentSurveyCustomFieldsModalComponent {
  public memberCustomValues: Array<CustomValue<any>>;
  public memberCustomValuesClone: Array<CustomValue<any>>;
  public customFields: Array<CustomField>;
  public customFieldConstants = CustomFieldConstants;

  constructor(public dynamicDialogRef: DynamicDialogRef,
              public dynamicDialogConfig: DynamicDialogConfig,
              public datePipe: DatePipe) {
    this.memberCustomValues = this.dynamicDialogConfig?.data?.memberCustomValues; // original - keep for back up. use for cancel button
    this.customFields = this.dynamicDialogConfig?.data?.customFields;
    this.memberCustomValuesClone = _.cloneDeep(this.memberCustomValues); // make changes to this one

    // format the value correctly or else it some fields will break
    this.memberCustomValuesClone.forEach((ma: CustomValue<any>) => {
      switch (ma.type.toLowerCase()) {
        case this.customFieldConstants.date.toLowerCase():
          ma.value = ma.value ? new Date(ma.value.replace(/-0(\d{1,2})-/, '-$1-')) : null;
          break;
        case this.customFieldConstants.multiselect.toLowerCase():
          ma.value = ma.value ? ma.value.map((v: CustomFieldDropdownChoice) => v.name) : null;
          break;
        case this.customFieldConstants.picklist.toLowerCase():
          ma.value = ma.value ? ma.value.name : null;
          break;
        case this.customFieldConstants.radio.toLowerCase():
          ma.value = ma.value ? ma.value.id : null;
          break;
      }
    });
  }

  close(data?: boolean): void {
    if (data) {
      // set the real injected to the changed value
      this.memberCustomValues = this.memberCustomValuesClone;

      // mold the value of each type to be what server expects
      // NOTE: using here == to avoid strict typing. can either be number or string type.
      this.memberCustomValues.forEach((ma: CustomValue<any>) => {
        switch (ma.type.toLowerCase()) {
          case this.customFieldConstants.multiselect.toLowerCase():
            const newValue: Array<any> = [];
            ma.value.forEach((v: any) => {
              newValue.push(this.getCustomField(ma.field.id).choices.find((c: CustomFieldDropdownChoice) => c.name === v));
            });
            ma.value = newValue;
            break;
          case this.customFieldConstants.date.toLowerCase():
            ma.value = this.datePipe.transform(ma.value, 'yyyy-MM-dd');
            break;
          case this.customFieldConstants.picklist.toLowerCase():
            ma.value = this.getCustomField(ma.field.id).choices.find((c: CustomFieldDropdownChoice) => c.name == ma.value) || ma.value;
            break;
          case this.customFieldConstants.radio.toLowerCase():
            ma.value = this.getCustomField(ma.field.id).choices.find((c: CustomFieldDropdownChoice) => c.id == ma.value) || ma.value;
            break;
        }
      });
    }

    this.dynamicDialogRef.close(this.memberCustomValues);
  }

  getCustomField(id: any): CustomField {
    return this.customFields.find((cf: CustomField) => Number(cf.id) === Number(id));
  }

  getStep(id: string): string {
    // TODO: get the correct step from decimals field
    return '0.01';
  }
}
